export default "__VITE_ASSET__10zFhArv__"